/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {Account} from '@ion/core/src/types/entities';
import {AuditRecordType} from '@ion/dls/src/editors/audit/AuditGridUtils';

// input selectors ...
const selectGridColumnState  = ({adminGroups: {grid}}) => grid?.columnState;
const selectAdd              = ({adminGroups: {add}}) => add;
const selectAddResult        = state => selectAdd(state).result;

const selectEdit             = ({adminGroups: {edit}}) => edit;
const selectEditShowDialog   = state => selectEdit(state).isEditing;
const selectEditIsViewMode   = state => selectEdit(state).isViewMode;
const selectEditResult       = state => selectEdit(state).result;

const selectAudit                  = ({adminGroups: {audit}}) => audit;
const selectAuditIsEditing         = state => selectAudit(state).isEditing;
const selectAuditSelected          = state => selectAudit(state).selected;
const selectAuditRecord            = state => selectAudit(state).auditRecord;
const selectAuditShowChangesDialog = state => selectAudit(state).showChangesDialog;

const selectDestroy          = ({adminGroups: {destroy}}) => destroy;
const selectDestroyResult    = state => selectDestroy(state).result;
const selectBulkImport       = ({adminGroups: {bulkImport}}) => bulkImport;
const selectBulkImportResult = state => selectBulkImport(state).result;
const selectModularSearch    = ({adminGroups: {search}}) => search;

const selectAddSSO           = ({adminGroups: {addSSO}}) => addSSO;
const selectAddSSOShowDialog = state => selectAddSSO(state).isEditing;
const selectAddSSOSelected   = state => selectAddSSO(state).selected;

const selectEditSSO           = ({adminGroups: {editSSO}}) => editSSO;
const selectEditSSOShowDialog = state => selectEditSSO(state).isEditing;
const selectEditSSOSelected   = state => selectEditSSO(state).selected;

// output selectors ...
export const adminGroupsGridColumnStateSelector = createDeepEqualSelector(selectGridColumnState,
  columnState => columnState
);

export const adminGroupsAddResultSelector = createDeepEqualSelector(selectAddResult,
  result => result
);

export const adminGroupsEditIsEditingSelector = createSelector(selectEditShowDialog,
  (isEditing: boolean): boolean => isEditing
);
export const adminGroupsEditIsViewModeSelector = createSelector(selectEditIsViewMode,
  (isViewMode: boolean): boolean => isViewMode
);
export const adminGroupsEditResultSelector = createDeepEqualSelector(selectEditResult,
  result => result
);

export const adminGroupsAuditIsEditingSelector = createSelector(selectAuditIsEditing,
  (isEditing: boolean): boolean => isEditing
);
export const adminGroupsAuditSelectedSelector = createDeepEqualSelector(selectAuditSelected,
  (selected: Account): Account => selected
);
export const adminGroupsAuditRecordSelector = createDeepEqualSelector(selectAuditRecord,
  (auditRecord: AuditRecordType): AuditRecordType => auditRecord
);
export const adminGroupsAuditShowChangesDialogSelector = createSelector(selectAuditShowChangesDialog,
  (showChangesDialog: boolean): boolean => showChangesDialog
);

export const adminGroupsDestroyResultSelector = createDeepEqualSelector(selectDestroyResult,
  result => result
);

export const adminGroupsBulkImportResultSelector = createDeepEqualSelector(selectBulkImportResult,
  result => result
);

export const adminGroupsModularSearchSelector = createDeepEqualSelector(selectModularSearch,
  search => search
);

export const addSSOShowDialogSelector = createSelector(selectAddSSOShowDialog,
  (isEditing: boolean) => isEditing
);
export const addSSOSelectedSelector = createDeepEqualSelector(selectAddSSOSelected,
  selected => selected
);
export const editSSOShowDialogSelector = createSelector(selectEditSSOShowDialog,
  (isEditing: boolean) => isEditing
);
export const editSSOSelectedSelector = createDeepEqualSelector(selectEditSSOSelected,
  selected => selected
);
